<template>
  <!-- Default group icon: generic document/folder placeholder for groups without a custom avatar -->
  <svg viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <rect width="56" height="56" fill="var(--color-accent-primary)" />
    <path
      d="M15.5 39.25V16.75H28V21.75H40.5V39.25H15.5ZM18 36.75H25.5V34.25H18V36.75ZM18 31.75H25.5V29.25H18V31.75ZM18 26.75H25.5V24.25H18V26.75ZM18 21.75H25.5V19.25H18V21.75ZM28 36.75H38V24.25H28V36.75ZM30.5 29.25V26.75H35.5V29.25H30.5ZM30.5 34.25V31.75H35.5V34.25H30.5Z"
      fill="var(--color-text-black-white)"
    />
  </svg>
</template>
